import { AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { OeAppService } from '../../shared/oe-app.service';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';
import { ProgressBarInputData } from '../../shared/types/ProgressBarInputData';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { PracticeSectionContent } from './practice-section.interface';


@Component({
  selector: 'lp2-practice-section',
  templateUrl: './practice-section.component.html',
  styleUrls: ['./practice-section.component.scss'],
})
export class PracticeSectionComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('practiceSectionContent') practiceSectionContents: QueryList<PracticeSectionContent>;
  @Input()
  activityPoints: Map<GamificationActivityType, number>;

  isMobile: boolean;

  practiceProgressData: Observable<ProgressBarInputData[]>;

  businessTopics: string[] = [
    'Business',
    'CEOs',
    'Companies',
    'Earnings Calls',
    'Engineering',
    'Finance',
    'Presentations',
    'Telephone',
    'Working',
  ];

  shouldDisplay$ = new BehaviorSubject<boolean>(true);
  interactiveVideosEnabled$: Observable<boolean>;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private levelProgressService: LevelProgressService,
    private oeApp: OeAppService,
    configurationService: ProfileServiceConfigurationService,
  ) {
    this.interactiveVideosEnabled$ = configurationService.isInteractiveVideosCarouselEnabled$();
  }

  ngOnInit() {
    this.isMobile = this.oeApp.isMobileDevice();
    this.practiceProgressData = this.levelProgressService.practiceLevelProgress$.pipe(
      map((practiceProgress) => [practiceProgress])
    );
  }

  ngAfterViewInit() {
    // the videos carousels mount once the flag loads, after the first view check
    this.practiceSectionContents.changes
      .pipe(
        startWith(this.practiceSectionContents),
        switchMap((contents: QueryList<PracticeSectionContent>) =>
          combineLatest(contents.map((content) => content.shouldDisplay$))
        ),
        map((shouldDisplay) => shouldDisplay.some(Boolean)),
        takeUntil(this.destroy$)
      )
      .subscribe((value) => this.shouldDisplay$.next(value));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/practice-section/practice-section.component.ts